import { ExternalLink } from 'lucide-react'

interface CreatorLinksProps {
  variant?: 'compact' | 'full' | 'footer' | 'receipt'
}

export function CreatorLinks({ variant = 'full' }: CreatorLinksProps) {
  const linkedin = "https://www.linkedin.com/in/mindful-abhay/"
  const buymeacoffee = "https://buymeacoffee.com/abhaypratapsingh"

  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-3 text-xs">
        <a href={linkedin} target="_blank" rel="noopener noreferrer" className="creator-link flex items-center gap-1">
          LinkedIn <ExternalLink size={11} />
        </a>
        <span className="text-[var(--text-subtle)]">·</span>
        <a href={buymeacoffee} target="_blank" rel="noopener noreferrer" className="creator-link flex items-center gap-1">
          Buy me a coffee <ExternalLink size={11} />
        </a>
      </div>
    )
  }

  if (variant === 'footer') {
    return (
      <div className="text-center text-sm pt-10 pb-8 border-t border-[var(--border)] mt-12 no-print">
        <div className="text-[var(--text-subtle)] mb-2">cartographer is a personal instrument for noticing when one event has been compressed into a global story about yourself or another.</div>
        <div className="flex justify-center gap-x-4">
          <a href={linkedin} target="_blank" rel="noopener noreferrer" className="creator-link">Abhay on LinkedIn</a>
          <span className="text-[var(--text-subtle)]">·</span>
          <a href={buymeacoffee} target="_blank" rel="noopener noreferrer" className="creator-link">Support the work</a>
        </div>
        <div className="mt-2 text-[10px] text-[var(--text-subtle)] tracking-widest">BUILT FOR THE EDGE • COMPRESSION MADE LEGIBLE</div>
      </div>
    )
  }

  if (variant === 'receipt') {
    return (
      <div className="mt-8 pt-4 border-t border-[#d4c9b5] text-[11px] text-[#5c5549] flex flex-wrap gap-x-3 gap-y-1">
        <span>Made with care by Abhay Pratap Singh</span>
        <a href={linkedin} target="_blank" rel="noopener noreferrer" className="underline decoration-dotted underline-offset-2 hover:decoration-solid">linkedin.com/in/mindful-abhay</a>
        <a href={buymeacoffee} target="_blank" rel="noopener noreferrer" className="underline decoration-dotted underline-offset-2 hover:decoration-solid">buymeacoffee.com/abhaypratapsingh</a>
      </div>
    )
  }

  return (
    <div className="card p-5 text-sm">
      <div className="label mb-2">MADE BY</div>
      <div className="text-[var(--text-bright)] mb-1">Abhay Pratap Singh</div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
        <a href={linkedin} target="_blank" rel="noopener noreferrer" className="creator-link inline-flex items-center gap-1">
          linkedin.com/in/mindful-abhay <ExternalLink size={13} />
        </a>
        <a href={buymeacoffee} target="_blank" rel="noopener noreferrer" className="creator-link inline-flex items-center gap-1">
          buymeacoffee.com/abhaypratapsingh <ExternalLink size={13} />
        </a>
      </div>
      <div className="mt-3 text-[13px] text-[var(--text-muted)]">
        If this cartographer helps you hold one experience without letting it stand in for your whole character (or theirs), the links above keep this kind of work alive.
      </div>
    </div>
  )
}
